import { Outlet } from "react-router-dom";
import { AsaHealthBanner } from "@/components/AsaHealthBanner";
import { Sidebar } from "@/components/Sidebar";
import { useAuth } from "@/lib/useAuth";

/**
 * Grid shell: sticky Sidebar on the left, scrolling Main on the right.
 * The Topbar is owned per-page so each screen can set its own title /
 * subtitle / filter visibility.
 *
 * Outlet is keyed on the active org id so that when the user switches
 * or creates an org, every page fully remounts — filters (appIds,
 * accountIds), form state, and any other component-local `useState`
 * are reset to the new org instead of leaking across tenant scope.
 */
export function AppShell() {
  const { user } = useAuth();
  return (
    <div className="app">
      <Sidebar />
      <main className="main">
        <AsaHealthBanner />
        <Outlet key={user?.org_id ?? "anon"} />
      </main>
    </div>
  );
}
